<template>
  <div v-if="noContent">

    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="galeria_imagem" v-if="showContent">
          <ul>
            <li v-for="item in items" v-if="item.thumb">
              <router-link :to="goToUrl(item)">
                <img v-if="item.thumb" :src="item.thumb">
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import {slugify} from '../../helpers/slugify';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Álbum',
        showContent: true,
        items: [],
        noContent: true,
        urlShowVideo: ''
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      // get('content/' + this.bloco.id).then(function (response) {
      self.showContent = true;
      // self.items = window.siteconfig.result.data.album;
      self.items = this.$store.getters['getSiteContent'].result.data.album;

      // });
    },
    watch: {
      items(items) {
        if (items.length === 0) {
          this.noContent = false;
        }
      }
    },
    methods: {
      setImageShow(image) {
        this.urlImageShow = image;
      },
      getUrl(id, string) {
        return '/album/' + id + '/' + slugify(string);
      },
      goToUrl(item) {
        return this.getUrl(item.id, item.name);
        // this.$router.push(url);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/AlbumList.vue